





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Heading extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/forms/components/heading/Heading.vue